<template>
  <ConfigurableDashboard dashboard-key="main" permission-key="Dashboard" :default-widgets="['news']" />
</template>
<script>
import ConfigurableDashboard from "../../components/ConfigurableDashboard.vue";

export default {
  name: "MainDashboard",
  components: { ConfigurableDashboard },
};
</script>
